import { useState } from "react";

//Use para copiar y pegar texto
export const useCopyAndPaste = () => {
    const [bengal, setBengal] = useState (false)
    const [value, setValue] = useState ('')

    /**
    * copy: función para copiar contenido al portapapeles
    * @param text :Valor que queremos copiar
    */
    const copy = (text) => {
        setTimeout(() => setBengal(false), 300)
        if (text) {
            navigator.clipboard.writeText(text)
                .then(() => {
                    setValue(text)
                    setBengal(true)
                    return true
                })
                .catch((err) => {
                    console.error('Error al copiar al portapapeles:', err);
                    return false
                });
        }

    };

    //Elimina el contenido
    const clear = () => setValue('')

    //pega texto
    const paste = async () => {
        setTimeout(() => setBengal(false), 300)

        try {
            const text = await navigator.clipboard.readText();
            setValue(text)
            setBengal(true)
            return text;
        } catch (err) {
            console.error('Error al pegar desde el portapapeles:', err);
            return '';
        }

    };

    return {
        copy,
        paste,
        bengal,
        value,
        clear,
        setValue
    }
}